import { render } from "./PersonalDataProcessingPolicyView.vue?vue&type=template&id=8e3465e2&scoped=true"
import script from "./PersonalDataProcessingPolicyView.vue?vue&type=script&lang=js"
export * from "./PersonalDataProcessingPolicyView.vue?vue&type=script&lang=js"

import "./PersonalDataProcessingPolicyView.vue?vue&type=style&index=0&id=8e3465e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e3465e2"]])

export default __exports__